import classNames from 'classnames';
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import DatePicker from 'components/base/DatePicker';
import { useTranslation } from 'react-i18next';

interface CertificateFormProps {
  className?: string;
  initialData?: any;
  onUpdate: (data: any) => void; // Function to update form data in parent component
}

const CertificateForm = ({ className, onUpdate, initialData }: CertificateFormProps) => {

  const { t } = useTranslation();
  // State to store the form data
  const [formData, setFormData] = useState<any>({
    certificate_from: '',
    certificate_title: '',
    certificate_date: null,

  });

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    onUpdate({ ...formData, [name]: value }); // Update the parent component's formData on every change
  };

  // Function to handle input changes
  const handleDatePickerChange = (fieldName: string, dateValues: any[]) => {
    setFormData({ ...formData, [fieldName]: dateValues[0] });
    onUpdate({ ...formData, [fieldName]: dateValues[0] }); // Update the parent component's formData on every change
  };

  useEffect(() => {
    if (initialData) {
      console.log(initialData);
      setFormData({
        certificate_from: initialData['certificate_from'],
        certificate_title: initialData['certificate_title'],
        certificate_date: new Date(initialData['certificate_date'])
      });
    }
  }, [initialData]);

  return (
    <div className={classNames('g-3', className)}>
      <h4 className="mb-3">Certificate Information</h4>

      <Row className='mb-2'>
        <Col>
          <FloatingLabel controlId="title" label="Title">
            <Form.Control type="text" placeholder="Title" required
              name='certificate_title' value={formData.certificate_title} onChange={handleInputChange}
            />
          </FloatingLabel>
        </Col>
      </Row>

      <Row className='mb-2'>
        <Col>
          <FloatingLabel controlId="certificate_from" label="Certificate emitted by">
            <Form.Control type="text" required
              name='certificate_from' value={formData.certificate_from} onChange={handleInputChange} />
          </FloatingLabel>
        </Col>
      </Row>
      <Row className='mb-2'>
        <Col>

          <DatePicker placeholder="Select Date"
            name='certificate_date' value={formData.certificate_date} onChange={(e) => handleDatePickerChange('certificate_date', e)}
          />

        </Col>



      </Row>
    </div>
  );
};

export default CertificateForm;

